import React from 'react';
import styled from 'styled-components';

import Button from 'components/atom/Button';

import { CostsSummaryProps } from './types';

const StickyWrapper = styled.div``;

const StickyContainer = styled.div`
    background: var(--color-alt);
    border-radius: var(--box-border-radius);
    padding: 16px 40px;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);

    @media (max-width: 1200px) {
        padding: 14px 24px;
    }

    @media (max-width: 768px) {
        padding: 12px 16px;
    }

    @media (max-width: 576px) {
        padding: 8px 12px;
    }
`;

const Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;

    @media (max-width: 576px) {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
    }
`;

const StatsGroup = styled.div`
    display: flex;
    gap: 28px;
    flex-wrap: wrap;
    align-items: center;

    @media (max-width: 1200px) {
        gap: 18px;
    }

    @media (max-width: 768px) {
        gap: 14px;
    }

    @media (max-width: 576px) {
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 6px 12px;
    }
`;

const StatItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1px;
`;

const StatLabel = styled.span`
    font-size: 11px;
    color: var(--color-alt-second);
    opacity: 0.7;

    @media (max-width: 1200px) {
        font-size: 10px;
    }

    @media (max-width: 768px) {
        font-size: 9px;
    }

    @media (max-width: 576px) {
        font-size: 8px;
    }
`;

const StatValue = styled.span`
    font-size: 18px;
    font-weight: 600;
    color: var(--color-white);

    @media (max-width: 1200px) {
        font-size: 13px;
    }

    @media (max-width: 768px) {
        font-size: 13px;
    }

    @media (max-width: 576px) {
        font-size: 12px;
    }
`;

const formatNumber = (num: number): string => {
    return num.toLocaleString('pl-PL');
};

const CostsSummary: React.FC<CostsSummaryProps> = ({
    totalCosts,
    projectBudget,
    estimatedProfitNetto,
    roi,
    margin,
    onGenerateReport,
    totalCostsLabel = 'Suma kosztów',
    projectBudgetLabel = 'Całkowity budżet projektu',
    profitLabel = 'Potencjalny zysk netto',
    buttonLabel = 'Generuj raport'
}) => {
    return (
        <StickyWrapper>
            <StickyContainer>
                <Content>
                    <StatsGroup>
                        <StatItem>
                            <StatLabel>{totalCostsLabel}</StatLabel>
                            <StatValue>{formatNumber(totalCosts)} zł</StatValue>
                        </StatItem>
                        <StatItem>
                            <StatLabel>{projectBudgetLabel}</StatLabel>
                            <StatValue>{formatNumber(projectBudget)} zł</StatValue>
                        </StatItem>
                        {estimatedProfitNetto != null &&
                            <StatItem>
                                <StatLabel>{profitLabel}</StatLabel>
                                <StatValue>{formatNumber(estimatedProfitNetto)} zł</StatValue>
                            </StatItem>
                        }
                        {roi != null &&
                            <StatItem>
                                <StatLabel>ROI</StatLabel>
                                <StatValue>{roi.toFixed(1)}%</StatValue>
                            </StatItem>
                        }
                        {margin != null &&
                            <StatItem>
                                <StatLabel>Marża brutto</StatLabel>
                                <StatValue>{margin.toFixed(1)}%</StatValue>
                            </StatItem>
                        }
                    </StatsGroup>
                    {onGenerateReport &&
                        <Button onClick={onGenerateReport}>
                            {buttonLabel}
                        </Button>
                    }
                </Content>
            </StickyContainer>
        </StickyWrapper>
    );
};

export default CostsSummary;
